export default {"src":"/_next/static/image/public/icons/control/star.99fcbbc7936a21c27592c80e762f175a.svg","height":24,"width":26};